"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _compose = _interopRequireDefault(require("recompose/compose"));

var _pure = _interopRequireDefault(require("recompose/pure"));

var _urlCatalog = _interopRequireDefault(require("@angi/url-catalog"));

var _angieslistAppPlatform = require("angieslist-app-platform");

var _headerAnalytics = _interopRequireDefault(require("./headerAnalytics"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var activityLocation = 'Leads Auth Header';

var AngiLeadsSubNavItems = function AngiLeadsSubNavItems(_ref) {
  var currentSubNav = _ref.currentSubNav,
      highlightSubNav = _ref.highlightSubNav,
      instantBookingEnabled = _ref.instantBookingEnabled,
      spId = _ref.spId,
      subNavStyling = _ref.subNavStyling,
      callTrackingFeatureFlag = _ref.callTrackingFeatureFlag,
      billingPageVariant = _ref.billingPageVariant,
      isAngiLeadsAdmin = _ref.isAngiLeadsAdmin;
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: "unified-header-sub-nav--leads-pro"
  }, currentSubNav === 'leads' ? [/*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, {
    key: "0"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "All leads",
    href: _urlCatalog["default"].office.leads.leadsBoard(spId),
    id: "unified-header-sub-nav--all-leads",
    onMouseEnter: function onMouseEnter() {
      return highlightSubNav('allLeads');
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: subNavStyling('allLeads')
  }, "All leads"))), instantBookingEnabled ? /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, {
    key: "1"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "Appointments",
    href: _urlCatalog["default"].office.leads.appointments(spId),
    id: "unified-header-sub-nav--appointments",
    onMouseEnter: function onMouseEnter() {
      return highlightSubNav('appointments');
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: subNavStyling('appointments')
  }, "Appointments"))) : null, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, {
    key: "2"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "Services",
    href: _urlCatalog["default"].office.leads.servicesOffered(spId),
    id: "unified-header-sub-nav--services",
    onMouseEnter: function onMouseEnter() {
      return highlightSubNav('services');
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: subNavStyling('services')
  }, "Services and tasks"))), /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, {
    key: "3"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "Coverage area",
    href: _urlCatalog["default"].office.leads.serviceArea(spId),
    id: "unified-header-sub-nav--service-area",
    onMouseEnter: function onMouseEnter() {
      return highlightSubNav('serviceArea');
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: subNavStyling('serviceArea')
  }, "Service locations"))), isAngiLeadsAdmin ? /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, {
    key: "4"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "Manage lead flow",
    href: _urlCatalog["default"].office.leads.manageLeads(spId),
    id: "unified-header-sub-nav--manage-lead-flow",
    onMouseEnter: function onMouseEnter() {
      return highlightSubNav('manageLeadFlow');
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: subNavStyling('manageLeadFlow')
  }, "Manage lead volume"))) : null] : currentSubNav === 'reviews' ? [/*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, {
    key: "0"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "All reviews",
    href: _urlCatalog["default"].office.leads.reviews(spId),
    id: "unified-header-sub-nav--all-reviews",
    onMouseEnter: function onMouseEnter() {
      return highlightSubNav('allReviews');
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: subNavStyling('allReviews')
  }, "All reviews"))), /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, {
    key: "1"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "Request reviews",
    href: _urlCatalog["default"].office.leads.requestReviews(spId),
    id: "unified-header-sub-nav--request-reviews",
    onMouseEnter: function onMouseEnter() {
      return highlightSubNav('requestReviews');
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: subNavStyling('requestReviews')
  }, "Request reviews"))), /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, {
    key: "2"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "Feedback",
    href: _urlCatalog["default"].office.leads.requestFeedback(spId),
    id: "unified-header-sub-nav--feedback",
    onMouseEnter: function onMouseEnter() {
      return highlightSubNav('requestFeedback');
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: subNavStyling('requestFeedback')
  }, "Feedback")))] : currentSubNav === 'myBusiness' ? [/*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, {
    key: "0"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "Settings",
    href: _urlCatalog["default"].office.leads.businessSettings(spId),
    id: "unified-header-sub-nav--settings",
    onMouseEnter: function onMouseEnter() {
      return highlightSubNav('settings');
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: subNavStyling('settings')
  }, "Business profile"))), isAngiLeadsAdmin ? [/*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, {
    key: "1-0"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "Monthly Budget",
    href: _urlCatalog["default"].office.leads.modifySpendTarget(spId),
    id: "unified-header-sub-nav--monthly-budget",
    onMouseEnter: function onMouseEnter() {
      return highlightSubNav('monthlyBudget');
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: subNavStyling('monthlyBudget')
  }, "Monthly budget"))), billingPageVariant === 'UNIFIED_BILLING_AND_PAYMENTS' ? /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, {
    key: "1-1"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "Billing and payments",
    href: _urlCatalog["default"].office.leads.billingAndPayments(spId),
    id: "unified-header-sub-nav--billing-and-payments",
    onMouseEnter: function onMouseEnter() {
      return highlightSubNav('billingAndPayments');
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: subNavStyling('billingAndPayments')
  }, "Billing and payments"))) : billingPageVariant === 'STATEMENTS' ? [/*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, {
    key: "1-1-0"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "Statements",
    href: _urlCatalog["default"].office.leads.statements(spId),
    id: "unified-header-sub-nav--statements",
    onMouseEnter: function onMouseEnter() {
      return highlightSubNav('statements');
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: subNavStyling('statements')
  }, "Statements"))), /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, {
    key: "1-1-1"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "Manage payments",
    href: _urlCatalog["default"].office.leads.managePayments(spId),
    id: "unified-header-sub-nav--manage-payments",
    onMouseEnter: function onMouseEnter() {
      return highlightSubNav('managePayments');
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: subNavStyling('managePayments')
  }, "Manage payments")))] : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null)] : null, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, {
    key: "2"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "Notification preferences",
    href: _urlCatalog["default"].office.leads.commPreferences(spId),
    id: "unified-header-sub-nav--notification-preferences",
    onMouseEnter: function onMouseEnter() {
      return highlightSubNav('commPreferences');
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: subNavStyling('commPreferences')
  }, "Notification preferences"))), /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, {
    key: "3"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "App integrations",
    href: _urlCatalog["default"].office.account.appIntegrations(spId),
    id: "unified-header-sub-nav--app-integrations",
    onMouseEnter: function onMouseEnter() {
      return highlightSubNav('appIntegrations');
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: subNavStyling('appIntegrations')
  }, "App integrations"))), /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, {
    key: "4"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "Manage team",
    href: _urlCatalog["default"].office.leads.manageTeam(spId),
    id: "unified-header-sub-nav--app-manage-team",
    onMouseEnter: function onMouseEnter() {
      return highlightSubNav('manageTeam');
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: subNavStyling('manageTeam')
  }, "Manage team"))), callTrackingFeatureFlag ? /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, {
    key: "5"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "Connected numbers",
    "data-intercom-target": "Connected numbers",
    id: "unified-header-sub-nav--connected-numbers",
    href: _urlCatalog["default"].office.leads.connectedNumbers(spId),
    onMouseEnter: function onMouseEnter() {
      return highlightSubNav('connectedNumbers');
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: subNavStyling('connectedNumbers')
  }, "Connected numbers"))) : null] : null);
};

var _default = (0, _compose["default"])((0, _angieslistAppPlatform.analytics)({
  ruleset: _headerAnalytics["default"]
}), // eslint-disable-next-line no-unused-vars
(0, _reactRedux.connect)(function (state, props) {
  return {};
}, _objectSpread({}, _angieslistAppPlatform.analyticsActions)), _pure["default"])(AngiLeadsSubNavItems);

exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-office-app-common/lib/v1/header/angiLeadsSubNavItems.js
// module id = 3577
// module chunks = 25